import AbstractFilter from './AbstractFilter.js'

export default class ManofacturerFilter extends AbstractFilter{
  	constructor(filterHandler, filterID) {
  		super(filterHandler, filterID, "ManofacturerFilter");

  		this.option_names = {
  			"Alle" : this.isAlleFilter,
  			"Glas Trösch" : this.isGlasTröschFilter,
  			"AGC" : this.isAGCFilter,
  			"Hero-Fire" : this.isHeroFireFilter
  		};


  		this.prepare_ui();
  	}

  	isAlleFilter() {
      return {
        frg : (aGlass) => { return true },
      };
  	}

  	isGlasTröschFilter() {
      return {
        frg : (aGlass) => { return aGlass.manufacturer.includes("Glas Trösch") },
      };
  	}

  	isAGCFilter() {
      return {
        frg : (aGlass) => { return aGlass.manufacturer.includes("AGC") },
      };
  	}

  	isHeroFireFilter() {
      return {
        frg : (aGlass) => { return aGlass.manufacturer.includes("Hero") },
      };
  	}
}

